import { LoadingStatus, StatusWidgetContainer } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { commonIcons } from '@apps-common/config/icons'
import classNames from 'classnames'

interface IProps {
  loading: boolean
  data: boolean | undefined
  classes?: string
}

export const ConnectivityStatus = ({ loading, data, classes }: IProps) => {
  const ConnectedIcon = commonIcons.connected
  const DisconnectedIcon = commonIcons.disconnected

  if (loading) {
    return <LoadingStatus />
  }

  return (
    <StatusWidgetContainer>
      <div
        className={classNames(
          classes,
          'text-text-muted text-center px-[6px] py-[4px] rounded-[12px] flex flex-col items-center justify-between gap-[2px] h-[50px] sm:h-[60px] w-[58px]'
        )}
      >
        <div className='grow px-[3px] rounded-[5px] sm:pt-[2px] jost-bold flex items-center justify-center'>
          {data ? <ConnectedIcon className='text-[22px] sm:text-[26px]' /> : <DisconnectedIcon className='text-[20px] sm:text-[26px]' />}
        </div>
        <div className='uppercase jost-medium text-[9px] sm:text-[9px] sm:pb-[3px]'>{data ? 'Online' : 'Offline'}</div>
      </div>
    </StatusWidgetContainer>
  )
}
